
/*
 * Date: 2025
 * Description: Form modal body
 * Author: Philippe Leroux @ SKITSC
 */

//Modules
import { Typography , Box , Grid ,  } from '@mui/material';
import { ReactElement , useState , forwardRef } from 'react';

//Components
import CloseModal from './close.modal';

//Styles
import { modal_style } from '../../styles/modal.styles';
import { getBigModalStyle } from '../../styles/modal.styles';

import { i_modal_form_props } from '../../interfaces/utility.interface';
import ScriptForm from '../form/script.form';
import QuestionForm from '../form/question.form';
import PaymentForm from '../form/payment.form';

const FormBody = forwardRef((props : i_modal_form_props , ref) : ReactElement => {
    const [ modalStyle ] = useState(getBigModalStyle(props.mode))
    return (
        <Box component={'div'} style={modalStyle} sx={modal_style}>
            <CloseModal {...props}></CloseModal>
            <Grid container sx={{ width : '100%'}}>
                <Grid size={12}>
                    <Typography sx={{ textAlign : "center" , marginBottom : '3vh' , marginTop : '0vh' , fontWeight : '700'}}variant={"h5"}>{props.title}</Typography>
                </Grid>
                <Grid size={12}>
                    {props.type === 'script' &&
                        <ScriptForm {...props} />
                    }
                    {props.type === 'question' &&
                        <QuestionForm {...props} />
                    }
                    {props.type === 'payment' &&
                        <PaymentForm {...props} />
                    }
                </Grid>
            </Grid>
        </Box>
    );
  })
  
  
  export default FormBody;